var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEqifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 76,
    viewBox: "0 0 173 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2171_44192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9869 52.863V23.1336H77.554V25.9702H63.0941V36.5101H77.2834V39.3477H63.0941V49.8876H77.6877V52.86H59.9839L59.9869 52.863ZM118.499 52.863V23.1336H121.337V52.863H118.499ZM156.069 52.863V23.1336H158.906V52.863H156.069ZM97.2847 49.8926C95.8105 49.8568 94.3582 49.5276 93.0127 48.9244C91.6671 48.3211 90.4552 47.4558 89.4477 46.379C88.344 45.2857 87.475 43.9786 86.8938 42.5379C86.3127 41.0971 86.0317 39.5529 86.0679 37.9998C86.0314 36.4467 86.3123 34.9024 86.8935 33.4616C87.4747 32.0208 88.3438 30.7138 89.4477 29.6207C90.4888 28.5139 91.7448 27.6314 93.1389 27.0272C94.5331 26.423 96.0359 26.1099 97.5553 26.107C99.0787 26.0835 100.59 26.3846 101.988 26.9904C103.386 27.5963 104.638 28.4929 105.663 29.6207C106.767 30.714 107.636 32.021 108.217 33.4618C108.798 34.9025 109.079 36.4467 109.043 37.9998C109.079 39.553 108.798 41.0972 108.217 42.538C107.636 43.9788 106.767 45.2858 105.663 46.379C105.244 46.8171 104.792 47.2236 104.313 47.5951H108.503C109.423 46.4352 110.195 45.1642 110.799 43.8119C111.571 41.9749 111.939 39.9935 111.879 38.0018C111.86 36.017 111.494 34.0509 110.799 32.1917C110.053 30.4433 109.001 28.8422 107.692 27.464C106.368 26.1151 104.812 25.0158 103.098 24.219C101.318 23.403 99.3799 22.9875 97.4215 23.0018C95.5068 22.9874 93.6134 23.4034 91.881 24.219C90.1673 25.0152 88.6111 26.1137 87.2871 27.462C85.9781 28.8403 84.9258 30.4414 84.1798 32.1897C83.408 34.0268 83.0396 36.0081 83.0995 37.9998C83.1189 39.9846 83.4845 41.9508 84.1798 43.8099C84.9258 45.5583 85.9781 47.1593 87.2871 48.5376C88.611 49.886 90.1672 50.9845 91.881 51.7807C93.57 52.5812 95.4156 52.9966 97.2847 52.9968H112.96V49.8896L97.2847 49.8926ZM130.392 36.5121V52.862H133.499V39.2149H146.202V36.5121H130.392ZM130.392 34.2166H133.499V25.8375H148.095V23.1346H130.391L130.392 34.2166Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 23.1339V52.9991H36.828L36.7677 48.9604H19.0407V27.1715H44.8682V23.1328L15 23.1339Z",
    fill: "url(#paint0_linear_2171_44192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0724 35.3432H40.8668V40.0298H23.0623V44.1661H40.8668V52.9999H44.8652V31.207H23.0724V35.3432Z",
    fill: "url(#paint1_linear_2171_44192)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2171_44192",
    x1: 15,
    y1: 23.1328,
    x2: 40.8343,
    y2: 48.9688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12204E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#08515D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42B294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2171_44192",
    x1: 25.2862,
    y1: 29.0059,
    x2: 47.0573,
    y2: 50.8088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12204E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#08515D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42B294"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2171_44192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143.905,
    height: 30,
    fill: "white",
    transform: "translate(15 23)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqifi);
export default __webpack_public_path__ + "static/media/eqifi.0422a62cf36400c9c25165b9371cd255.svg";
export { ForwardRef as ReactComponent };